import { Card, CardActionArea, CardActions, CardContent, CardMedia, Typography, Button } from '@mui/material';
import React, { FC } from 'react';
import { FoerderProgrammProps } from '../../../../../lib/types/types';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { get } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { itemData } from '../../../homepage/HomePage';

import Schema from '../../../../../lib/paths/foerderprogramm_FULL_Paths.json';
const P = Schema.attributes;

const FoerderProgrammGrid: FC<FoerderProgrammProps> = ({ data }) => {
	const navigate = useNavigate();

	return (
		<>
			<Grid container spacing={5} columns={3}>
				{(data || []).map((ele, i) => (
					<Grid xs={3} sm={1} key={i}>
						<Card
							raised
							sx={{ maxWidth: '25rem' }}
							onClick={() => navigate(`/foerderprogramm/details/${get(ele, 'id', -1)}`)}
						>
							<CardActionArea component="div">
								<CardMedia component={'img'} height={265} image={itemData[i].img} alt="Elektro mobilitäts" />
								<CardContent>
									<Typography
										gutterBottom
										variant="h6"
										component={'div'}
										sx={{
											mb: '1rem',
											fontWeight: 600,
											height: '2.8rem', // Adjust the height to match 5 lines of text
											lineHeight: '1.3rem', // Line height for body2
											overflow: 'hidden',
											display: '-webkit-box',
											WebkitBoxOrient: 'vertical',
											WebkitLineClamp: 2,
										}}
									>
										{get(ele, P.Allgemein_Name.path)}
									</Typography>
									<Typography
										variant="body1"
										component={'div'}
										sx={{
											height: '6.5rem', // Adjust the height to match 5 lines of text
											lineHeight: '1.3rem', // Line height for body2
											overflow: 'hidden',
											display: '-webkit-box',
											WebkitBoxOrient: 'vertical',
											WebkitLineClamp: 5,
										}}
									>
										<div
											id="no-margin"
											dangerouslySetInnerHTML={{
												__html: get(ele, P.Allgemein_Beschreibung.path, ''),
											}}
										></div>
									</Typography>
								</CardContent>
								<CardActions>
									<Button endIcon={<KeyboardArrowRightIcon />}>Mehr erfahren</Button>
								</CardActions>
							</CardActionArea>
						</Card>
					</Grid>
				))}
			</Grid>
		</>
	);
};

export default FoerderProgrammGrid;
